<template>
  <div>
    <v-card>
      <v-card-title>
        <v-tabs v-model="tab" background-color="primary" dark>
          <v-tab @click="_obtenerBilleteras">Billeteras</v-tab>
          <v-tab @click="obtenerGastos">Gastos</v-tab>
          <v-tab @click="_obtenerTransferencias">Transferencias</v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>
              <v-col cols="9"
                ><v-card>
                  <v-card-title
                    ><v-tabs v-model="tabBilletera">
                      <v-tab
                        v-for="(item, index) in billeteras"
                        :key="index"
                        @click="_seleccionarBilletera(index)"
                        >{{ item.nombre }}</v-tab
                      >
                    </v-tabs></v-card-title
                  >
                  <v-card-text>
                    <span v-if="billetera.movimientos.length == 0"
                      >Aun no hubo movimientos.</span
                    >
                    <v-data-table
                      v-else
                      :headers="encabezadosMovimientos"
                      :items="billetera.movimientos"
                      :items-per-page="5"
                      class="elevation-1"
                      ><template v-slot:item.ingreso="{ item }">
                        <v-btn icon @click="_verMovimiento(item)"
                          ><v-icon>mdi-eye</v-icon></v-btn
                        >
                        <v-icon :color="item.ingreso ? 'green' : 'red'">{{
                          item.ingreso ? "mdi-arrow-right" : "mdi-arrow-left"
                        }}</v-icon> </template
                      ><template v-slot:item.fechaAlta="{ item }">
                        {{ $moment(item.fechaAlta).format("DD/MM/YYYY HH:mm") }}
                      </template></v-data-table
                    >
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3"
                ><v-card>
                  <v-card-title>$ {{ billetera.disponible }}</v-card-title>
                  <v-card-text>Dinero disponible</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-btn
              fab
              absolute
              top
              right
              color="green"
              dark
              @click="dialogIngresarGasto"
              ><v-icon>mdi-plus</v-icon></v-btn
            >
            <v-data-table
              :headers="encabezadosGastos"
              :items="gastos"
              :items-per-page="5"
              class="elevation-1"
              :loading="loadingGastos"
              ><template v-slot:item.accion="{ item }">
                <v-btn icon @click="_verGasto(item._id)"
                  ><v-icon>mdi-eye</v-icon></v-btn
                > </template
              ><template v-slot:item.fechaAlta="{ item }">
                {{ $moment(item.fechaAlta).format("DD/MM/YYYY HH:mm") }}
              </template>
              <template v-slot:item.comprobante="{ item }">
                {{ item.comprobante.tipo }} - {{ item.comprobante.numero }}
              </template></v-data-table
            >
          </v-tab-item>
          <v-tab-item>
            <v-btn
              fab
              absolute
              top
              right
              color="green"
              dark
              @click="_dialogIngresarTransferencia"
              ><v-icon>mdi-plus</v-icon></v-btn
            >
            <v-data-table
              :headers="encabezadosTransferencias"
              :items="transferencias"
              :items-per-page="5"
              class="elevation-1"
              :loading="loadingTransferencias"
              ><template v-slot:item.accion="{ item }">
                <v-btn icon @click="_verTransferencia(item._id)"
                  ><v-icon>mdi-eye</v-icon></v-btn
                > </template
              ><template v-slot:item.fechaAlta="{ item }">
                {{ $moment(item.fechaAlta).format("DD/MM/YYYY HH:mm") }}
              </template>
              <template v-slot:item.descripcion="{ item }">
                {{
                  item.descripcion == "" ? "Sin descripcion" : item.descripcion
                }}
              </template></v-data-table
            >
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="32"></v-progress-circular>
      </v-overlay>
    </v-card>
    <v-dialog v-model="dialogAgregarGasto" persistent max-width="500">
      <v-card>
        <v-card-title>Ingresar gasto</v-card-title>
        <v-card-text>
          <v-text-field
            label="Descripcion"
            v-model="gasto.descripcion"
            @input="$v.gasto.descripcion.$touch()"
            @blur="$v.gasto.descripcion.$touch()"
            :error="$v.gasto.descripcion.$error"
          ></v-text-field>
          <v-autocomplete
            :items="tipoComprobante"
            label="Tipo de Comprobante"
            v-model="gasto.comprobante.tipo"
          ></v-autocomplete>
          <v-text-field
            label="N° de Comprobante"
            v-model="gasto.comprobante.numero"
            @input="$v.gasto.comprobante.numero.$touch()"
            @blur="$v.gasto.comprobante.numero.$touch()"
            :error="$v.gasto.comprobante.numero.$error"
          ></v-text-field>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Billetera
                  </th>
                  <th class="text-left">
                    Monto
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in gasto.pagos" :key="index">
                  <td>{{ item.descripcion }}</td>
                  <td>{{ item.monto }}</td>
                </tr>
                <tr>
                  <td>
                    <v-autocomplete
                      :items="billeteras"
                      item-text="nombre"
                      item-value="_id"
                      v-model="pago.billetera"
                      @input="$v.pago.billetera.$touch()"
                      @blur="$v.pago.billetera.$touch()"
                      :error="$v.pago.billetera.$error"
                    ></v-autocomplete>
                  </td>
                  <td>
                    <v-text-field
                      v-model="pago.monto"
                      type="number"
                      prefix="$"
                      @input="$v.pago.monto.$touch()"
                      @blur="$v.pago.monto.$touch()"
                      :error="$v.pago.monto.$error"
                      ><template v-slot:append-outer>
                        <v-btn
                          icon
                          @click="_agregarPagoGasto"
                          :color="$v.pago.$invalid ? 'red' : 'green'"
                        >
                          <v-icon>
                            mdi-plus
                          </v-icon>
                        </v-btn></template
                      ></v-text-field
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-text-field
            label="Monto"
            prefix="$"
            v-model="gasto.monto"
            disabled
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAgregarGasto = false"
            >Cerrar</v-btn
          >
          <v-btn
            :color="$v.gasto.$invalid ? 'red' : 'green'"
            text
            :loading="loadingAgregarGasto"
            @click="agregarGasto()"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogIngresarTransferencia" persistent max-width="500">
      <v-card>
        <v-card-title>Ingresar transferencia</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="transferencia.origen"
            @input="$v.transferencia.origen.$touch()"
            @blur="$v.transferencia.origen.$touch()"
            :error="$v.transferencia.origen.$error"
            :items="billeteras"
            item-text="nombre"
            item-value="_id"
            label="Billetera de Origen"
          ></v-autocomplete>
          <v-autocomplete
            v-model="transferencia.destino"
            @input="$v.transferencia.destino.$touch()"
            @blur="$v.transferencia.destino.$touch()"
            :error="$v.transferencia.destino.$error"
            :items="billeteras"
            item-text="nombre"
            item-value="_id"
            label="Billetera de Destino"
          ></v-autocomplete>
          <v-text-field
            type="number"
            :prefix="esDolarCompra ? 'USD' : '$'"
            v-model="transferencia.monto"
            @input="$v.transferencia.monto.$touch()"
            @blur="$v.transferencia.monto.$touch()"
            :error="$v.transferencia.monto.$error"
            label="Monto"
          ></v-text-field>
          <div v-if="esDolarCompra">
            <v-text-field
              type="number"
              prefix="$"
              v-model="dolares.precioCompra"
              @input="$v.dolares.precioCompra.$touch()"
              @blur="$v.dolares.precioCompra.$touch()"
              :error="$v.dolares.precioCompra.$error"
              label="Precio de Compra USD"
            ></v-text-field>
            <v-text-field
              type="number"
              prefix="$"
              v-model="precioUnidadUSD"
              label="Precio por Unidad USD"
              disabled
            ></v-text-field>
          </div>
          <div v-if="esDolarVenta">
            <v-text-field
              type="number"
              prefix="$"
              v-model="dolares.precioVenta"
              @input="$v.dolares.precioVenta.$touch()"
              @blur="$v.dolares.precioVenta.$touch()"
              :error="$v.dolares.precioVenta.$error"
              label="Precio de Venta USD"
            ></v-text-field>
            <v-text-field
              type="number"
              prefix="$"
              v-model="precioUnidadUSD"
              label="Precio por Unidad USD"
              disabled
            ></v-text-field>
          </div>
          <v-textarea
            v-model="transferencia.descripcion"
            label="Descripcion"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogIngresarTransferencia = false"
            >Cerrar</v-btn
          >
          <v-btn
            :color="validarTransferencia ? 'green' : 'red'"
            text
            :loading="loadingAgregarTransferencia"
            @click="agregarTransferencia()"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
const greaterThanZero = (value) => value > 0;
export default {
  name: "Home",
  validations: {
    gasto: {
      descripcion: { required, minLength: minLength(3) },
      comprobante: {
        numero: { required, minLength: minLength(3) },
      },
      pagos: { required },
    },
    pago: {
      billetera: { required },
      monto: { required, greaterThanZero },
    },
    transferencia: {
      origen: { required },
      destino: { required },
      monto: { required, greaterThanZero },
    },
    dolares: {
      precioCompra: { required, greaterThanZero },
      precioVenta: { required, greaterThanZero },
    },
  },
  data() {
    return {
      tab: 0,
      tabBilletera: 0,
      billetera: {
        movimientos: [],
      },
      billeteras: [],
      gastos: [],
      transferencias: [],
      encabezadosMovimientos: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "ingreso",
        },
        {
          text: "Fecha y Hora",
          value: "fechaAlta",
        },
        {
          text: "Descripcion",
          value: "descripcion",
        },
        {
          text: "Monto",
          value: "monto",
        },
      ],
      encabezadosGastos: [
        {
          text: "",
          align: "start",
          value: "accion",
        },
        {
          text: "Fecha y Hora",
          value: "fechaAlta",
        },
        {
          text: "Descripcion",
          value: "descripcion",
        },
        {
          text: "Comprobante asociado",
          value: "comprobante",
        },
        {
          text: "Monto",
          value: "monto",
        },
      ],
      encabezadosTransferencias: [
        {
          text: "",
          align: "start",
          value: "accion",
        },
        {
          text: "Fecha y Hora",
          value: "fechaAlta",
        },
        {
          text: "Descripcion",
          value: "descripcion",
        },
        {
          text: "Origen",
          value: "origen.nombre",
        },
        {
          text: "Destino",
          value: "destino.nombre",
        },
        {
          text: "Monto",
          value: "monto",
        },
      ],
      loadingGastos: false,
      dialogAgregarGasto: false,
      loadingAgregarGasto: false,
      gasto: {
        descripcion: "",
        monto: 0,
        comprobante: {
          tipo: "REMITO X",
          numero: "",
        },
        pagos: [],
      },
      pago: {
        billetera: "",
        monto: 0,
      },
      tipoComprobante: [
        "FACTURA C",
        "FACTURA B",
        "FACTURA A",
        "REMITO X",
        "DEPOSITO BANCARIO",
      ],
      dolares: {
        precioCompra: 0,
        precioVenta: 0,
      },
      loading: false,
      dialogIngresarTransferencia: false,
      transferencia: {
        origen: "",
        destino: "",
        monto: 0,
        descripcion: "",
        dolares: null,
      },
      loadingAgregarTransferencia: false,
      loadingTransferencias: false,
    };
  },
  computed: {
    esDolarCompra() {
      if (this.transferencia.destino) {
        if (
          this.billeteras.find((obj) => obj._id == this.transferencia.destino)
            .tipo == "DOLARES"
        ) {
          return true;
        }
      }
      return false;
    },
    esDolarVenta() {
      if (this.transferencia.origen) {
        if (
          this.billeteras.find((obj) => obj._id == this.transferencia.origen)
            .tipo == "DOLARES"
        ) {
          return true;
        }
      }
      return false;
    },
    precioUnidadUSD() {
      if (this.transferencia.monto > 0) {
        if (this.esDolarCompra && this.dolares.precioCompra > 0)
          return parseFloat(
            this.dolares.precioCompra / this.transferencia.monto
          ).toFixed(2);
        if (this.esDolarVenta && this.dolares.precioVenta > 0)
          return parseFloat(
            this.dolares.precioVenta / this.transferencia.monto
          ).toFixed(2);
      }
      return 0;
    },
    validarTransferencia() {
      if (this.esDolarCompra) {
        if (this.$v.dolares.precioCompra.$invalid) return false;
      }
      if (this.esDolarVenta) {
        if (this.$v.dolares.precioVenta.$invalid) return false;
      }
      if (this.$v.transferencia.$invalid) return false;
      return true;
    },
  },
  methods: {
    async _obtenerBilleteras() {
      try {
        const billeteras = await axios.get("/billeteras");
        this.billeteras = billeteras.data;
        this._seleccionarBilletera(0);
      } catch (error) {
        alert("No se pudo cargar la lista de billeteras.");
      }
    },
    _seleccionarBilletera(index) {
      this.billetera = this.billeteras[index];
      this.billetera.movimientos = this.billetera.movimientos.reverse();
    },
    _verGasto(id) {
      this.$router.push(`/gastos/${id}`);
    },
    _verTransferencia(id) {
      this.$router.push(`/transferencias/${id}`);
    },
    _verMovimiento(item) {
      if (item.venta) {
        this.$router.push(`/ventas/${item.venta}`);
      } else if (item.gasto) {
        this.$router.push(`/gastos/${item.gasto}`);
      } else if (item.transferencia) {
        this.$router.push(`/transferencias/${item.transferencia}`);
      } else if(item.arqueo) {
        this.$router.push(`/arqueos/${item.arqueo}`);
      }else if(item.compra) {
        this.$router.push(`/compras/${item.compra}`);
      }
    },
    dialogIngresarGasto() {
      this.gasto = {
        descripcion: "",
        monto: 0,
        comprobante: {
          tipo: "REMITO X",
          numero: "",
        },
        pagos: [],
      };
      this.pago = {
        billetera: this.billeteras[0]._id,
        monto: 0,
      };
      this.$v.gasto.$reset();
      this.dialogAgregarGasto = true;
    },
    _agregarPagoGasto() {
      this.$v.pago.$touch();
      if (!this.$v.pago.$invalid) {
        let descripcion = this.billeteras.find(
          (obj) => obj._id == this.pago.billetera
        ).nombre;
        this.gasto.pagos.push({ ...this.pago, descripcion });
        this.gasto.monto += parseFloat(this.pago.monto);
        this.pago = {
          billetera: "",
          monto: 0,
        };
        this.$v.pago.$reset();
      }
    },
    async agregarGasto() {
      this.$v.gasto.$touch();
      if (!this.$v.gasto.$invalid) {
        this.loadingAgregarGasto = true;
        try {
          const gasto = await axios.post("/gastos/nuevo", this.gasto);
          this.$router.push(`/gastos/${gasto.data._id}`);
        } catch (error) {
          alert("No se pudo agregar el gasto. Por favor, reintente.");
        }
        this.loadingAgregarGasto = false;
      }
    },
    async obtenerGastos() {
      this.loadingGastos = true;
      try {
        const gastos = await axios.get("/gastos");
        this.gastos = gastos.data;
      } catch (error) {
        alert("No se pudo cargar los gastos.");
      }
      this.loadingGastos = false;
    },
    _dialogIngresarTransferencia() {
      this.transferencia = {
        origen: "",
        destino: "",
        monto: 0,
        descripcion: "",
      };
      this.dolares = {
        precioCompra: 0,
      };
      this.$v.transferencia.$reset();
      this.dialogIngresarTransferencia = true;
    },
    async agregarTransferencia() {
      this.$v.transferencia.$touch();
      this.$v.dolares.$touch();
      if (this.validarTransferencia) {
        if (this.transferencia.origen == this.transferencia.destino) {
          alert("La billetera de origen y destino no pueden coincidir.");
        } else {
          this.loadingAgregarTransferencia = true;
          if (this.esDolarCompra) {
            this.dolares.precioUnidad = this.precioUnidadUSD;
            delete this.dolares.precioVenta;
            this.transferencia.dolares = this.dolares;
          }
          if (this.esDolarVenta) {
            this.dolares.precioUnidad = this.precioUnidadUSD;
            delete this.dolares.precioCompra;
            this.transferencia.dolares = this.dolares;
          }
          try {
            const transferencia = await axios.post(
              "/transferencias/nuevo",
              this.transferencia
            );
            this.dialogIngresarTransferencia = false;
            this._obtenerTransferencias();
          } catch (error) {
            alert(
              "No se pudo registrar la transferencia, por favor reintente."
            );
          }
          this.loadingAgregarTransferencia = false;
        }
      }
    },
    async _obtenerTransferencias() {
      this.loadingTransferencias = true;
      try {
        const transferencias = await axios.get("/transferencias");
        this.transferencias = transferencias.data;
      } catch (error) {
        alert("No se pudo obtener el listado de transferencias.");
      }
      this.loadingTransferencias = false;
    },
  },
  async created() {
    this.loading = true;
    await this._obtenerBilleteras();
    this.loading = false;
  },
};
</script>
